import { render, staticRenderFns } from "./Payflex.vue?vue&type=template&id=c15627c2&scoped=true"
import script from "./Payflex.vue?vue&type=script&lang=js"
export * from "./Payflex.vue?vue&type=script&lang=js"
import style0 from "./Payflex.vue?vue&type=style&index=0&id=c15627c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15627c2",
  null
  
)

export default component.exports